<template>
    <app-select
        :multiple="true"
        v-model="selected"
        :data-title="'Redes'"
        :data-menu-heading="'Redes'"
        :data-button-gradient="true"
        :data-items="formattedList" />
  </template>

  <script>
  import AppSelect from "@components/Select";
  import _ from "lodash";

  export default {
    components: {
      AppSelect,
    },

    data() {
      return {
        list: [],
        selected: []
      };
    },

    computed: {
      formattedList() {
        return this.list.map((item) => {
          return {
            id: item.id,
            label: item.name,
          }
        })
      },

    },

    watch: {
        selected(val) {
            this.$store.commit('STATISTICS_SET_FILTER', {
                key: 'networks',
                value: val
            })
        }
    },

    methods: {
      async loadList() {
        this.list = await this.$api.beholder.getMonitorNetworks();
      },
    },

    async mounted() {
        this.loadList();
    },
  };
  </script>

